import { Spin } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearListCompactAction,
  listAgenciesCompactAction,
} from "../../store/agency/agencyActions";
import { clearReminderList } from "../../store/reminder/reminderActions";
import PermissionWrapper from "../navigation/PermissionWrapper";
import { UpdateRenewalData } from "../shared/securityRoleTasks";
import ManageRemindersForm from "./ManageRemindersForm";
import { Route, Routes } from "react-router-dom";
import ReminderForm from "./ReminderForm";
import { PreservableStatePageWrapper } from "../shared/PreservableStatePageWrapper";
import { tableNames } from "../shared/table/tableNames";

const ManageReminders = () => {
  //
  const dispatch = useDispatch();

  //
  const brokerId = useSelector((state) => state.actor.details.data.BrokerId);
  const agencies = useSelector((state) => state.agency.listCompact);
  const agenciesLoading = useSelector((state) => state.agency.loading);
  //
  const pageLoaded = brokerId != null && agencies != null && !agenciesLoading;

  //
  useEffect(() => {
    if (brokerId != null) {
      dispatch(listAgenciesCompactAction(brokerId, UpdateRenewalData));
    }
  }, [brokerId, dispatch]);

  useEffect(() => {
    dispatch(clearListCompactAction());
    dispatch(clearReminderList());
  }, []);

  return (
    <PreservableStatePageWrapper
      onCleanup={() => {}}
      tableNames={[tableNames.ManageReminders]}
    >
      <PermissionWrapper entityName="ManageReminders">
        <Routes>
          <Route
            path=""
            element={
              <Spin spinning={!pageLoaded} delay={500}>
                {pageLoaded && <ManageRemindersForm agencies={agencies} />}
              </Spin>
            }
          />
          <Route path="reminderform/:requestId" element={<ReminderForm />} />
        </Routes>
      </PermissionWrapper>
    </PreservableStatePageWrapper>
  );
};

export default ManageReminders;
